var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    [
      _c("NOSComponent", {
        ref: "NOS_COMPONENT",
        attrs: { component: this.NOS_INSTANCE.components }
      }),
      _c(
        "div",
        { staticClass: "scroll" },
        [
          _c("contents-header", {
            attrs: {
              bgType: true,
              noRadius: true,
              "title-img2": true,
              "customer-css": "mb0",
              title: "AOTP-02-01-01-01",
              description: "AOTP-02-01-01-02",
              description2: "AOTP-02-01-01-03"
            },
            scopedSlots: _vm._u([
              {
                key: "img2",
                fn: function() {
                  return [
                    _c("i", { staticClass: "icon icon-advanced-otp-touch" })
                  ]
                },
                proxy: true
              }
            ])
          }),
          _c("article", { staticClass: "contents" }, [
            _c("div", { staticClass: "form" }, [
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "item-tit" }, [
                  _vm._v(
                    " " +
                      _vm._s(/*OTP 기기 일련번호*/ _vm.$t("MOTP-01-07-05-03")) +
                      " "
                  )
                ]),
                _c("div", { staticClass: "item-desc" }, [
                  _c("div", { staticClass: "form-text-field otp" }, [
                    _c("div", { staticClass: "input-text-field" }, [
                      _c("input", {
                        staticClass: "form-control",
                        attrs: { type: "text", id: "name", disabled: "" },
                        domProps: { value: _vm.getCheckOtp.in.otpUniqIdnfiNo }
                      })
                    ])
                  ])
                ])
              ]),
              _c("div", { staticClass: "form-text-field" }, [
                _c(
                  "label",
                  { staticClass: "form-label", attrs: { for: "name" } },
                  [_vm._v(_vm._s(/*인증번호 */ _vm.$t("MOTP-01-07-05-04")))]
                ),
                _c(
                  "div",
                  { staticClass: "input-text-field" },
                  [
                    _c("advanced-otp-input", {
                      attrs: {
                        NOS_INSTANCE_REFERANCE: _vm.NOS_INSTANCE,
                        "is-input-hidden": false
                      }
                    })
                  ],
                  1
                )
              ]),
              _c(
                "div",
                {
                  staticClass: "info info-help",
                  on: {
                    click: function($event) {
                      _vm.infoOpened = true
                    }
                  }
                },
                [
                  _c("i", { staticClass: "icon icon-help" }),
                  _vm._v(
                    _vm._s(/*인증번호 확인 방법*/ _vm.$t("AOTP-02-01-01-04"))
                  )
                ]
              )
            ])
          ])
        ],
        1
      ),
      _c("div", { staticClass: "btn-area--full fixed" }, [
        _c("button", { staticClass: "btn md normal" }, [
          _vm._v(_vm._s(/*인증하기*/ _vm.$t("MOTP-01-07-05-05")))
        ])
      ]),
      _c("action-sheet", {
        attrs: {
          opened: _vm.infoOpened,
          "no-negative-button": false,
          confirm: "MCOM-0000003",
          title: "AOTP-02-01-01-04"
        },
        on: {
          "update:opened": function($event) {
            _vm.infoOpened = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [
                _c("ol", { staticClass: "olist olist-number-type2" }, [
                  _c("li", { staticClass: "num" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          /*Advanced OTP에 Unlock Button을 길게 누르면 기기 전원이 켜집니다.*/ _vm.$t(
                            "AOTP-02-01-01-05"
                          )
                        ) +
                        " "
                    )
                  ]),
                  _c("li", { staticClass: "num" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          /*사용자 PIN을 입력한 후 Unlock Button을 누릅니다.*/ _vm.$t(
                            "AOTP-02-01-01-06"
                          )
                        ) +
                        " "
                    )
                  ]),
                  _c("li", { staticClass: "num" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          /*화면에 \"Adv_OtP\"가 표시되면, OTP모드를 선택할 수 있습니다.*/ _vm.$t(
                            "AOTP-02-01-01-07"
                          )
                        ) +
                        " "
                    )
                  ]),
                  _c("li", { staticClass: "num" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          /*Button 1(OTP)를 누르면 기기 화면에 7자리 인증번호가 표시됩니다.*/ _vm.$t(
                            "AOTP-02-01-01-08"
                          )
                        ) +
                        " "
                    )
                  ]),
                  _c("li", { staticClass: "num" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          /*기기에서 확인한 인증번호를 입력하시면 됩니다.*/ _vm.$t(
                            "AOTP-02-01-01-09"
                          )
                        ) +
                        " "
                    )
                  ])
                ]),
                _c("i", { staticClass: "icon icon-adv-otp-touch" })
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }